const settings = [
	{
		path: '/ai/settings',
		name: 'ai-settings-list',
		component: () => import('@/views/ai/settings/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAI,agents',
		},
	},
]

export default settings
